import { useSite } from "./site";

/**
 * Card payments can be paused from settings (site.shop.checkout_enabled) while Stripe is
 * being set up. When paused, the cart and checkout disappear and every buy button becomes
 * an enquiry - prices stay visible so people still know what things cost.
 */
export function useCheckoutEnabled() {
  const { site } = useSite();
  const flag = site?.shop?.checkout_enabled;
  return flag !== false;          // default open; only an explicit false pauses payments
}
